export function useShouldShowToggleLargeDocumentViewAction() {
  return true;
}
